<template>
  <CCard class="contactInfo pt-5">
    <CRow>
      <CCol sm="12">
        <header class="contactInfo__header d-flex justify-content-between">
          <h3 class="contactInfo__title font-weight-normal">
            {{ $t('audience.detailContact.optIn-optOut') }}
          </h3>
        </header>
      </CCol>
      <CCol sm="12">
        <div class="contactInfo__body p-0">
          <div>
            <ul class="listOptInOut d-flex p-0 mt-4 text-gray-700">
              <li v-for="(item, index) in modelCopy" :key="index" class="mr-5 d-flex flex-column justify-content-center listOptInOutItem">
                <div class="d-flex align-items-center justify-content-center mb-3">
                  <CIcon :title="item.title" :name="item.name" class="mr-2" size="custom-size" :height="23" :viewBox="item.viewBox" />
                  {{ item.name }}
                  <CustomTooltip v-if="item.name === 'email' && !item.status && getUnsubBySpamOrHardBouncedText" placement="right" class="ml-4">
                    <CButton class="p-0">
                      <CIcon name="infoSolid" class="text-primary" style="width: 25; height: 25" viewBox="0 0 32 32" />
                    </CButton>
                    <template v-slot:content>
                      <span>{{ getUnsubBySpamOrHardBouncedText }}</span>
                    </template>
                  </CustomTooltip>
                </div>

                <div v-if="loading" class="d-flex justify-content-center align-items-center">
                  <CSpinner class="my-3" color="primary" />
                </div>

                <ToogleSwitch v-else :stateSwith="item.status" @toggle-switch="handleModel($event, item)" />

                <!-- <div v-else class="btn-group text-gray-700" :class="[item.status == true ? 'btn-group--on':'btn-group--off']" role="group" aria-label="First group">
                      <button type="button" @click="handleModel(item, true)"  class="btn btn__on">ON</button>
                      <button type="button" @click="handleModel(item, false)" class="btn btn__off">OFF</button>
                  </div> -->
              </li>
            </ul>
          </div>
        </div>
      </CCol>
      <CCol sm="12">
        <transition name="fade">
          <MenssageAlert :messages="messages" />
        </transition>
      </CCol>
    </CRow>
  </CCard>
</template>

<script>
import services from '@/services.js'
import MenssageAlert from '@/components/MenssageAlert'
import ToogleSwitch from '@/components/ToogleSwitch'
import { ACTIVITY_TYPES, ACTIVITY_TYPE_NAMES } from '../../constants'
import CustomTooltip from '@/components/CustomTooltip.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ContactOptInOut',
  components: {
    MenssageAlert,
    ToogleSwitch,
    CustomTooltip,
  },
  data() {
    return {
      loading: false,
      recipient: [],
      messages: [],
      modelCopy: {},
      model: {
        EMAIL: { name: 'email', title: 'e-mail', viewBox: '0 0 32 32', status: false },
        SMS: { name: 'sms', title: 'SMS', viewBox: '0 0 38 32', status: false },
        // VOICE:{name:"voice", title: "Voice",  viewBox: '0 0 32 32',  status: false},
        // PUSH_NOTIFICATION:{name:"pushNotification",  title: "Push Notification", viewBox: '0 0 32 32',  status: false}
      },
      ACTIVITY_TYPES,
      ACTIVITY_TYPE_NAMES,
    }
  },

  methods: {
    handleModel($event, item) {
      if (!this.isCurrentOrganizationBase) {
        this.messages = [
          {
            status: 'warning',
            text: this.$t('audience.detailContact.consentNotChange'),
          },
        ]

        return
      }
      this.modelCopy[item.name.toUpperCase()].status = $event
      this.sendSubscriptions()
    },

    handleSubsciptions() {
      const arr = []

      for (var prop in this.modelCopy) {
        if (this.modelCopy[prop].status) {
          arr.push(prop)
        }
      }

      return arr
    },

    sendSubscriptions() {
      this.messages = []
      this.loading = true

      services
        .recipientSubscriptions(this.$route.params.organizationId, this.$route.params.id, this.handleSubsciptions())
        .then(({ data }) => {
          this.messages.push({
            status: 'success',
            text: data.message || 'Opt in & Opt out saved',
          })
        })

        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message,
          })
        })

        .finally(() => {
          this.model = this.modelCopy
          this.loading = false
        })
    },
  },

  computed: {
    ...mapGetters({
      isOrganizationBase: 'auth/isOrganizationBase',
    }),

    isCurrentOrganizationBase() {
      return this.isOrganizationBase(this.$route.params.organizationId)
    },

    getterRecipient() {
      if (this.$store.state.audience.recipient) {
        return JSON.parse(JSON.stringify(this.$store.state.audience.recipient))
      }
      return []
    },

    getUnsubBySpamOrHardBouncedText() {
      if (this.$store.state.audience.audienceFeed) {
        const matched = this.$store.state.audience.audienceFeed.find(
          (feed) => ACTIVITY_TYPES[6] === ACTIVITY_TYPES[feed.idActivityType] || ACTIVITY_TYPES[7] === ACTIVITY_TYPES[feed.idActivityType],
        )

        if (!matched) return

        return this.$t(`campaign.detail.feed.${ACTIVITY_TYPE_NAMES[matched.idActivityType]}`)
      }
    },
  },
  watch: {
    getterRecipient(newValues) {
      this.recipient = newValues
      newValues._MetaData.Subscriptions.forEach((item) => {
        if (this.model[item]) {
          this.model[item].status = true
        }
      })

      this.modelCopy = JSON.parse(JSON.stringify(this.model))
    },
  },
}
</script>

<style lang="scss" scoped>
.listOptInOutItem {
  min-width: 120px;
}
</style>
